import { render, staticRenderFns } from "./addPanelDialog.vue?vue&type=template&id=6cdc5da6&scoped=true&"
import script from "./addPanelDialog.vue?vue&type=script&lang=js&"
export * from "./addPanelDialog.vue?vue&type=script&lang=js&"
import style0 from "./addPanelDialog.vue?vue&type=style&index=0&id=6cdc5da6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cdc5da6",
  null
  
)

export default component.exports